export default "__VITE_ASSET__B6_5gtR1__"